module.exports = __webpack_public_path__ + "static/media/Landing_page.0cc69066.jpg";